const formationSchemas = [
  {
    id: '2',
    formation: '442',
    orderSchema: ['1', '2', '5', '6', '3', '7', '4', '8', '11', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '11',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '4',
          content: null,
        },
      ],
    ],
  },
  {
    id: '3',
    formation: '41212',
    orderSchema: ['1', '2', '5', '6', '3', '4', '7', '11', '8', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '4',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '8',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '10',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '9',
        },
        {
          span: '2',
          content: null,
        },
      ],
    ],
  },
  {
    id: '4',
    formation: '433',
    orderSchema: ['1', '2', '5', '6', '3', '7', '4', '8', '10', '9', '11'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '4',
          content: '7',
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '4',
          content: '8',
        },
        {
          span: '1',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '10',
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '2',
          content: null,
        },
      ],
    ],
  },
  {
    id: '5',
    formation: '451',
    orderSchema: ['1', '2', '5', '6', '3', '4', '10', '8', '7', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '2',
          content: '7',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '3',
          content: '8',
        },
        {
          span: '2',
          content: '11',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '6',
    formation: '4411',
    orderSchema: ['1', '2', '5', '6', '3', '7', '4', '8', '11', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '1',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '10',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '7',
    formation: '4141',
    orderSchema: ['1', '2', '5', '6', '3', '4', '7', '8', '10', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '4',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '3',
          content: '11',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '8',
    formation: '4231',
    orderSchema: ['1', '2', '5', '6', '3', '8', '4', '7', '10', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '4',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '9',
    formation: '4321',
    orderSchema: ['1', '2', '5', '6', '3', '8', '4', '7', '10', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '8',
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '2',
          content: '11',
        },
        {
          span: '4',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '10',
    formation: '532',
    orderSchema: ['1', '2', '6', '5', '4', '3', '7', '8', '11', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: '2',
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: '3',
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '4',
          content: '7',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '4',
          content: '11',
        },
        {
          span: '1',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '4',
          content: '10',
        },
        {
          span: '4',
          content: '9',
        },
        {
          span: '2',
          content: null,
        },
      ],
    ],
  },
  {
    id: '11',
    formation: '541',
    orderSchema: ['1', '2', '6', '5', '4', '3', '7', '8', '10', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: '2',
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: '3',
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '1',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '12',
    formation: '352',
    orderSchema: ['1', '6', '5', '4', '7', '11', '8', '2', '3', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: '2',
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '11',
        },
        {
          span: '3',
          content: '8',
        },
        {
          span: '2',
          content: '3',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '4',
          content: null,
        },
      ],
    ],
  },
  {
    id: '13',
    formation: '343',
    orderSchema: ['1', '6', '5', '4', '2', '7', '8', '3', '10', '9', '11'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '7',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '3',
        },
        {
          span: '1',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '10',
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '2',
          content: null,
        },
      ],
    ],
  },
  {
    id: '15',
    formation: '4222',
    orderSchema: ['1', '2', '5', '6', '3', '4', '8', '7', '11', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '3',
          content: '5',
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '4',
          content: '4',
        },
        {
          span: '4',
          content: '8',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '7',
        },
        {
          span: '6',
          content: null,
        },
        {
          span: '3',
          content: '11',
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '4',
          content: '10',
        },
        {
          span: '4',
          content: '9',
        },
        {
          span: '2',
          content: null,
        },
      ],
    ],
  },
  {
    id: '16',
    formation: '3511',
    orderSchema: ['1', '6', '5', '4', '7', '11', '8', '2', '3', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: '2',
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '11',
        },
        {
          span: '3',
          content: '8',
        },
        {
          span: '2',
          content: '3',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '10',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '17',
    formation: '3421',
    orderSchema: ['1', '6', '5', '4', '2', '7', '8', '3', '10', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '7',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '2',
          content: '11',
        },
        {
          span: '4',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '18',
    formation: '3412',
    orderSchema: ['1', '6', '5', '4', '2', '7', '8', '3', '9', '10', '11'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '7',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '3',
        },
        {
          span: '1',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '2',
          content: '11',
        },
        {
          span: '4',
          content: null,
        },
      ],
    ],
  },
  {
    id: '19',
    formation: '3142',
    orderSchema: ['1', '5', '4', '6', '8', '2', '7', '11', '3', '9', '10'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '5',
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '8',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '7',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '11',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '4',
          content: null,
        },
      ],
    ],
  },
  {
    id: '20',
    formation: '343d',
    orderSchema: ['1', '6', '5', '4', '8', '2', '3', '7', '10', '9', '11'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: '6',
        },
        {
          span: '4',
          content: '5',
        },
        {
          span: '4',
          content: '4',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '8',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: '2',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '4',
          content: '3',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '7',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: '10',
        },
        {
          span: '4',
          content: '9',
        },
        {
          span: '4',
          content: '11',
        },
      ],
    ],
  },
  {
    id: '21',
    formation: '4132',
    orderSchema: ['1', '2', '5', '6', '3', '4', '7', '8', '11', '9', '10'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '4',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '4',
          content: null,
        },
      ],
    ],
  },
  {
    id: '22',
    formation: '4240',
    orderSchema: ['1', '2', '5', '6', '3', '4', '8', '7', '9', '10', '11'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '4',
          content: null,
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '1',
          content: null,
        },
      ],
    ],
  },
  {
    id: '23',
    formation: '4312',
    orderSchema: ['1', '2', '5', '6', '3', '7', '4', '11', '8', '9', '10'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '8',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '4',
          content: null,
        },
      ],
    ],
  },
  {
    id: '24',
    formation: '3241',
    orderSchema: ['1', '6', '5', '4', '2', '3', '10', '7', '8', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '2',
        },
        {
          span: '2',
          content: '3',
        },
        {
          span: '4',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '10',
        },
        {
          span: '2',
          content: '7',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '11',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '25',
    formation: '3331',
    orderSchema: ['1', '6', '5', '4', '2', '8', '3', '10', '7', '11', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '4',
          content: '6',
        },
        {
          span: '4',
          content: '5',
        },
        {
          span: '4',
          content: '4',
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '3',
          content: '3',
        },
        {
          span: '2',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '10',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '7',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '11',
        },
      ],
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '9',
        },
        {
          span: '3',
          content: null,
        },
      ],
    ],
  },
  {
    id: '26',
    formation: '424',
    orderSchema: ['1', '2', '5', '6', '3', '4', '8', '7', '9', '10', '11'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '3',
          content: '2',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '2',
          content: null,
        },
        {
          span: '2',
          content: '6',
        },
        {
          span: '3',
          content: '3',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '4',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '4',
          content: null,
        },
      ],
      [
        {
          span: '1',
          content: null,
        },
        {
          span: '3',
          content: '7',
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '2',
          content: '10',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '1',
          content: null,
        },
      ],
    ],
  },
  {
    id: '27',
    formation: '523',
    orderSchema: ['1', '2', '6', '5', '4', '3', '7', '8', '11', '10', '9'],
    formationSchema: [
      [
        {
          span: '3',
          content: null,
        },
        {
          span: '6',
          content: '1',
        },
        {
          span: '3',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: '2',
        },
        {
          span: '3',
          content: '6',
        },
        {
          span: '2',
          content: '5',
        },
        {
          span: '3',
          content: '4',
        },
        {
          span: '2',
          content: '3',
        },
      ],
      [
        {
          span: '4',
          content: null,
        },
        {
          span: '2',
          content: '7',
        },
        {
          span: '2',
          content: '8',
        },
        {
          span: '4',
          content: null,
        },
      ],
      [
        {
          span: '2',
          content: null,
        },
        {
          span: '3',
          content: '10',
        },
        {
          span: '2',
          content: '9',
        },
        {
          span: '3',
          content: '11',
        },
        {
          span: '2',
          content: null,
        },
      ],
    ],
  },
];

export default formationSchemas;



// WEBPACK FOOTER //
// ./src/lib/common/formationSchemas/formationSchemas.js